var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 5.375C8.36719 5.375 8.61328 4.80078 8.25781 4.44531L4.75781 0.945312C4.53906 0.726562 4.18359 0.726562 3.96484 0.945312L0.464844 4.44531C0.109375 4.80078 0.355469 5.375 0.847656 5.375H7.875Z",
    fill: "#28A745"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownGreen);
export default __webpack_public_path__ + "static/media/dropdown-green.0afc5cd3.svg";
export { ForwardRef as ReactComponent };